// extracted by mini-css-extract-plugin
export var phone = "_21-0";